var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunelyMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Funely") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EEF3F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(22 32 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 54C31 41 31.3 27 32.6 14",
    stroke: "#3E5A7A",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6F98C8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0C4.5-6.2 11.5-6.2 16 0C11.5 6.2 4.5 6.2 0 0Z",
    transform: "translate(31.6 45) rotate(-145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C4.5-6.2 11.5-6.2 16 0C11.5 6.2 4.5 6.2 0 0Z",
    transform: "translate(31.4 31) rotate(-148)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3E5A7A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0C4.5-6.2 11.5-6.2 16 0C11.5 6.2 4.5 6.2 0 0Z",
    transform: "translate(31.5 38) rotate(-35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C4.5-6.2 11.5-6.2 16 0C11.5 6.2 4.5 6.2 0 0Z",
    transform: "translate(31.8 24) rotate(-32)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C4-5.4 10-5.4 14 0C10 5.4 4 5.4 0 0Z",
    transform: "translate(32.6 16) rotate(-90)",
    fill: "#6F98C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunelyMark);
export default __webpack_public_path__ + "static/media/funely-mark.ea19781409b6c07af66baad34709d8dc.svg";
export { ForwardRef as ReactComponent };